/**
 * Strip HTML tags and decode HTML entities from a string
 */
export const stripHTML = (html: string): string => {
  return html.replace(/<[^>]*>/g, "").replace(/&nbsp;/g, " ");
};

/**
 * Check if a URL points to an SVG image
 * react-pdf doesn't support SVG images
 */
export const isSvg = (url: string | null | undefined): boolean => {
  return url?.toLowerCase().endsWith(".svg") ?? false;
};

/**
 * Get the best available image URL for PDF rendering
 * Prioritizes non-SVG images
 */
export const getBestImageUrl = (
  imageUrl: string | null | undefined,
  thumbnailUrl: string | null | undefined
): string | null => {
  if (imageUrl && !isSvg(imageUrl)) {
    return imageUrl;
  }
  if (thumbnailUrl && !isSvg(thumbnailUrl)) {
    return thumbnailUrl;
  }
  return null;
};
